import { render } from "./Exam.vue?vue&type=template&id=0271b145&scoped=true"
import script from "./Exam.vue?vue&type=script&lang=js"
export * from "./Exam.vue?vue&type=script&lang=js"

import "./Exam.vue?vue&type=style&index=0&id=0271b145&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0271b145"]])

export default __exports__